import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const useAreaTypeValidationSchema = () => {
	const { t } = useTranslation()

	const boothTypeValidationSchema = yup.object({
		name: yup.string().required(t('Name is required')),
		dimensions: yup.object({
			height: yup.string().required(t('Height is required')),
			width: yup.string().required(t('Width is required')),
			depth: yup.string().required(t('Depth is required'))
		}),
		availability_algorithm: yup
			.string()
			.oneOf(['any_available', 'no_gap'])
			.default('any_available')
			.required(t('Algorithm is required'))
	})

	return yupResolver(boothTypeValidationSchema)
}
